import { Head, Link, useForm } from '@inertiajs/react'
import { HomeMark } from '../../shared/HomeMark.jsx'
import { withSiteFooter } from '../../shared/SiteFooter.jsx'
import { Button } from '../../components/core/Button.jsx'
import { Field } from '../../components/forms/Field.jsx'
import { Input } from '../../components/forms/Input.jsx'
import { Alert } from '../../components/feedback/Alert.jsx'

export default function LogIn({ errors = {}, flash = {} }) {
  const form = useForm({ email: '', password: '' })

  function submit(e) {
    e.preventDefault()
    form.post('/session')
  }

  return (
    <>
      <Head title="Sign in" />
      <main className="mx-auto flex min-h-screen w-full max-w-md flex-col justify-center gap-8 px-6 py-16">
        <HomeMark />
        <div className="flex flex-col gap-2">
          <h1 className="page-title">Sign in</h1>
          <p className="text-[15px] text-[color:var(--text-body)]">
            See how AI assistants answer when someone in your city is looking for a business like yours.
          </p>
        </div>

        {flash.notice && (
          <Alert tone="data" icon="info">
            {flash.notice}
          </Alert>
        )}
        {flash.alert && (
          <Alert tone="signal" icon="lock">
            {flash.alert}
          </Alert>
        )}

        {/* Re-applied on integration. `SessionsController` writes both of its failures — a wrong password and the rate limit — to
            `errors.base`, and no field on this page reads that key — so the
            failure returned a clean redirect and the page said **nothing at
            all**. An error nobody prints is the quiet half of the one-flat-bag
            problem in CLAUDE.md, and on sign-in it landed on the most-used form
            in the product. Verified in a browser 2026-09-24: the message is in
            the props and the page never renders it. */}
        {errors.base && (
          <Alert tone="signal" icon="alert-circle">
            {errors.base}
          </Alert>
        )}

        <form onSubmit={submit} className="flex flex-col gap-5">
          <Field label="Email" htmlFor="email" error={errors.email}>
            <Input
              id="email"
              name="email"
              type="email"
              autoComplete="email"
              value={form.data.email}
              invalid={Boolean(errors.email)}
              onChange={(e) => form.setData('email', e.target.value)}
            />
          </Field>

          <Field label="Password" htmlFor="password" error={errors.password}>
            <Input
              id="password"
              name="password"
              type="password"
              autoComplete="current-password"
              value={form.data.password}
              invalid={Boolean(errors.password)}
              onChange={(e) => form.setData('password', e.target.value)}
            />
          </Field>

          <Button variant="primary" size="lg" block as="button" loading={form.processing}>
            Sign in
          </Button>
        </form>

        <div className="flex flex-col gap-2 text-[13.5px] text-[color:var(--text-muted)]">
          <Link href="/passwords/new" className="underline underline-offset-4">
            Reset your password
          </Link>
          <span>
            No account yet?{' '}
            <Link href="/sign-up" className="underline underline-offset-4">
              Start free
            </Link>
          </span>
        </div>
      </main>
    </>
  )
}

LogIn.layout = withSiteFooter
